<template>
  <!-- 志愿者注销 -->
  <div class="page-reservation-setting">
    <div class="c-p">
      <i @click="back" class="el-icon-back" style="font-size: 24px"></i>
    </div>
    <div class="content">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="150px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="博物馆名称 :">
              <span>{{detailData.museumName}}</span>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="博物馆主页图片 :">
              <cmp-upload style="width: 100%;" :callFun="uploadCallback" :fileList="remoteFileList" :businessType="`reservation`" :accept="`image/*`" :multipleType="false" :showName="true" :showTip="false" :txt="`本地上传`" :isPicDiff="true" imgWidth="200px" imgHeight="120px"></cmp-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="预约时段 :">
              <el-row class="mb-30" v-for="(item, index) in form.appointTimes" :key="index">
                <el-col :span="8">
                  <el-form-item label=" " :prop="'appointTimes.'+index+'.timeStr'" :rules="rules.timeStr" label-width="20px">
                    <el-time-picker is-range v-model="item.timeStr" format="HH:mm" :value-format="'HH:mm'" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="开放票数 :" :prop="'appointTimes.'+index+'.openNum'" :rules="rules.openNum" label-width="100px">
                    <el-input v-model.number="item.openNum" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开放场次 :" :prop="'appointTimes.'+index+'.openVal'" :rules="rules.openVal" label-width="100px">
                    <el-select v-model="item.openVal" multiple collapse-tags>
                      <el-option v-for="item in openList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="tc" :span="2">
                  <svg-icon v-show="form.appointTimes.length>3" icon-class="dele" class-name="g-pointer" @click.native="hanleDele(index)" style="font-size: 20px;margin-top:8px;" />
                </el-col>
              </el-row>

              <div>
                <a class="m-btn" @click="handleAdd">添加时段</a>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="闭馆日期 :" prop="closeTime">
              <el-select v-model="form.closeTime" multiple>
                <el-option v-for="item in closeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
              <!-- <el-select v-model="form.closeTime" multiple>
                <el-option
                  v-for="item in closeList"
                  :key="item.dictCode"
                  :label="item.dictName"
                  :value="item.dictCode"
                ></el-option>
              </el-select>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="footer mt-30">
        <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">保存</el-button>
        <!-- <el-button @click="reset">重置</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import cmpUpload from '@cmp/my-upload/index' //上传组件
export default {
  components: { cmpUpload },
  data() {
    return {
      loadingSave: false,
      form: {
        appointTimes: []
        // closeTime: []
      },
      formCopy: {},
      detailData: {},
      rules: {
        timeStr: [{ required: true, message: '必填', trigger: 'blur' }],
        openNum: [
          { required: true, message: '必填', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ],
        openVal: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      remoteFileList: [],
      openList: [
        { name: '每周一', value: '1' },
        { name: '每周二', value: '2' },
        { name: '每周三', value: '3' },
        { name: '每周四', value: '4' },
        { name: '每周五', value: '5' },
        { name: '每周六', value: '6' },
        { name: '每周日', value: '7' }
      ],
      closeList: [],
      optionList2: [{ name: '且', value: '1' }]
    }
  },
  methods: {
    init() {
      this.getDropdownValue()
      this.getDetail()

      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
      })
    },
    // 详情
    getDetail() {
      this.formCopy = { ...this.form }
      this.$http.get('/AppointSetting/load', {}).then(res => {
        if (res.success) {
          let data = res.result
          this.detailData = data.item || {}
          let arr = []
          data.appointTimesList.forEach(item => {
            arr.push({
              ...item,
              timeStr: [item.startTime, item.endTime],
              openVal: item.openTimes.split(',')
            })
          })
          this.$set(this.form, 'appointTimes', arr)
          this.$set(this.form, 'imgId', this.detailData.imgId)
          // this.$set(this.form, 'closeTime', this.detailData.closeTime)
          this.$set(
            this.form,
            'closeTime',
            this.detailData.closeTime.split(',')
          )
          this.remoteFileList = [
            {
              attPath: this.detailData.imgUrl,
              attId: this.detailData.imgId,
              attFileTypeStr: 'img'
            }
          ]
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'close_time' })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '请选择' }]
            this.closeList = firstArr.concat(state)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleAdd() {
      this.form.appointTimes.push({
        timeStr: ['', '18:00'],
        openNum: '',
        openVal: ''
      })
    },
    back(){
      this.$router.go(-1)
    },
    hanleDele(index) {
      this.form.appointTimes.splice(index, 1)
    },
    uploadCallback(ids) {
      this.form.imgId = ids
    },
    // 保存
    fromSubmit(form) {
      if (!this.form.imgId) {
        this.$message.info('请上传博物馆主页图片')
        return
      }
      let arr = []
      this.form.appointTimes.forEach(item => {
        arr.push({
          id: item.id,
          startTime: item.timeStr[0],
          endTime: item.timeStr[1],
          openNum: item.openNum,
          openTimes: item.openVal.join(',')
        })
      })
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/AppointSetting/save', {
              ...this.form,
              appointTimes: JSON.stringify(arr),
              closeTime: this.form.closeTime.join(',')
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('保存成功')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 取消
    reset() {
      this.form = { ...this.formCopy }
      // this.$refs['form'].resetFields()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.page-reservation-setting {
  padding: 20px 40px;
  background: #fff;
  border-radius: 4px;
  .c-p{
    cursor: pointer;
  }
  .content {
    .m-tit {
      line-height: 40px;
    }
    .footer {
      padding-left: 150px;
    }
  }
}
</style>

